module.exports = __webpack_public_path__ + "img/stzqLb_banner.7ac9852.png";